<template>
    <section class="ghost-sites-list-stack sites-list-stack">
        <div class="container">
            <header class="component-header" v-if="showHeader">
                <h2 v-html="title" class="headline-2"></h2>
            </header>
            <ul class="stack">
                <li v-for="card in cards" :key="card.id">
                    <GhostSite type="list" :item="card" :itinerary="itinerary" @updateSingleItem="updateSingleItem" />
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup>
    // Emits
    const emit = defineEmits(['updateSingleItem']);

    // Props
    const props = defineProps({
        itinerary: {
            type: Object,
            required: false,
            default: {},
        },

        cards: {
            type: Array,
            required: true,
            default: [],
        },

        showHeader: {
            type: Boolean,
            required: false,
            default: true,
        },

        componentLocation: {
            type: String,
            required: false,
            default: '',
        },
    });

    const { itinerary, cards, showHeader, componentLocation } = toRefs(props);

    // Computed
    const total = computed(() => {
        return cards.value.length || 0;
    });
    const title = computed(() => {
        if (componentLocation && componentLocation.value) {
            switch (componentLocation.value.toLowerCase()) {
                case 'neighborhood':
                    return `Sites In This Neighborhood (${total.value})`;

                case 'itinerary':
                    return `Sites On This Itinerary (${total.value})`;
            }
        }
    });

    // Methods
    function updateSingleItem(item) {
        emit('updateSingleItem', item);
    }
</script>

<style lang="scss" scoped>
    .itinerary-detail .sites-list-stack .container {
        padding: 0;
        
        .component-header {
            margin-bottom: 16px;
        }
    }
</style>
